/**
 * Client-safe tax transaction constants + types. Exported as a subpath so
 * `apps/app` can import them without pulling in the tRPC server stub.
 */

export const TAX_TRANSACTION_TYPES = [
  'estimated_payment',
  'balance_due',
  'refund',
  'withholding',
  'property_tax',
  'other',
] as const;
export type TaxTransactionType = (typeof TAX_TRANSACTION_TYPES)[number];

export const TAX_JURISDICTIONS = ['federal', 'state', 'local'] as const;
export type TaxJurisdiction = (typeof TAX_JURISDICTIONS)[number];

export type TaxTransactionRow = {
  id: string;
  transactionId: string | null;
  goalId: string | null;
  type: TaxTransactionType;
  jurisdiction: TaxJurisdiction;
  taxYear: number;
  amount: number;
  note: string | null;
  linkedTransaction: {
    date: string;
    name: string;
    amount: number;
  } | null;
};

export type UncategorizedTaxTransaction = {
  transactionId: string;
  date: string;
  name: string;
  amount: number;
  plaidDetailed: string;
};
